// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* VoiceAudioPopover.css - Ultra-modern Audio Engine Switcher */

.audio-popover-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1050;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  animation: popoverFadeIn 0.18s cubic-bezier(0.16, 1, 0.3, 1);
}

.audio-popover-backdrop.above-sidebar {
  align-items: flex-end;
  justify-content: flex-start;
  padding: 0 0 75px 16px;
}

.audio-popover-backdrop.above-hero {
  align-items: center;
  justify-content: center;
  padding: 16px;
}

@keyframes popoverFadeIn {
  from {
    opacity: 0;
    transform: scale(0.97);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.audio-popover-box {
  width: 380px;
  max-width: 95vw;
  background: #18191c;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.65), 0 0 0 1px rgba(255, 255, 255, 0.05);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Header */
.audio-popover-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.03);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.audio-popover-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.2px;
}

.sparkle-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(135deg, #a855f7, #6366f1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-shadow: 0 2px 8px rgba(168, 85, 247, 0.4);
}

.popover-close-btn {
  background: transparent;
  border: none;
  color: #949ba4;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.popover-close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

/* Live VU Meter */
.audio-live-visualizer {
  padding: 12px 16px;
  background: rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.visualizer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.live-mic-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.6px;
  color: #b5bac1;
}

.live-engine-tag {
  font-size: 11px;
  font-weight: 600;
  color: #dbdee1;
}

.vu-meter-bar {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  overflow: hidden;
  position: relative;
}

.vu-meter-fill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.08s ease, background-color 0.2s ease;
  box-shadow: 0 0 10px currentColor;
}

/* Engine Choices List */
.audio-engine-list {
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 280px;
  overflow-y: auto;
}

.audio-engine-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  cursor: pointer;
  transition: all 0.15s ease;
}

.audio-engine-item:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}

.audio-engine-item.selected.krisp {
  background: rgba(168, 85, 247, 0.12);
  border-color: #a855f7;
}

.audio-engine-item.selected.krus {
  background: rgba(16, 185, 129, 0.12);
  border-color: #10b981;
}

.audio-engine-item.selected.rnnoise {
  background: rgba(249, 115, 22, 0.12);
  border-color: #f97316;
}

.audio-engine-item.selected.webrtc {
  background: rgba(88, 101, 242, 0.12);
  border-color: #5865F2;
}

.audio-engine-item.selected.off {
  background: rgba(239, 68, 68, 0.12);
  border-color: #ef4444;
}

.engine-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
}

.engine-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.engine-name {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
}

.engine-badge {
  font-size: 9px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.engine-badge.krisp {
  background: rgba(168, 85, 247, 0.25);
  color: #d8b4fe;
  border: 1px solid rgba(168, 85, 247, 0.4);
}

.engine-badge.krus {
  background: rgba(16, 185, 129, 0.25);
  color: #6ee7b7;
  border: 1px solid rgba(16, 185, 129, 0.4);
}

.engine-badge.rnnoise {
  background: rgba(249, 115, 22, 0.25);
  color: #fdba74;
  border: 1px solid rgba(249, 115, 22, 0.4);
}

.engine-badge.webrtc {
  background: rgba(88, 101, 242, 0.25);
  color: #c7d2fe;
  border: 1px solid rgba(88, 101, 242, 0.4);
}

.engine-desc {
  margin: 0;
  font-size: 11px;
  color: #949ba4;
  line-height: 1.35;
}

.check-icon {
  color: #5865F2;
  flex-shrink: 0;
  margin-left: 8px;
}

.audio-engine-item.selected.krisp .check-icon {
  color: #a855f7;
}

.audio-engine-item.selected.krus .check-icon {
  color: #10b981;
}

.audio-engine-item.selected.rnnoise .check-icon {
  color: #f97316;
}

.audio-engine-item.selected.off .check-icon {
  color: #ef4444;
}

/* Fine-tuning Slider */
.popover-slider-section {
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.02);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.slider-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11px;
  font-weight: 600;
  color: #b5bac1;
  margin-bottom: 8px;
}

.slider-val {
  color: #5865f2;
  font-weight: 700;
}

.quick-popover-slider {
  width: 100%;
  accent-color: #5865F2;
  height: 4px;
  cursor: pointer;
}

/* Footer */
.audio-popover-footer {
  padding: 10px 16px;
  background: rgba(0, 0, 0, 0.35);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  justify-content: center;
}

.full-audio-settings-link {
  background: transparent;
  border: none;
  color: #949ba4;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.15s ease;
}

.full-audio-settings-link:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.05);
}
`, "",{"version":3,"sources":["webpack://./src/components/Soundboard/VoiceAudioPopover.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,4DAA4D;AAC9D;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,gFAAgF;EAChF,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,wDAAwD;EACxD,iCAAiC;AACnC;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,+CAA+C;EAC/C,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC","sourcesContent":["/* VoiceAudioPopover.css - Ultra-modern Audio Engine Switcher */\n\n.audio-popover-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1050;\n  background: rgba(0, 0, 0, 0.45);\n  backdrop-filter: blur(4px);\n  display: flex;\n  animation: popoverFadeIn 0.18s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.audio-popover-backdrop.above-sidebar {\n  align-items: flex-end;\n  justify-content: flex-start;\n  padding: 0 0 75px 16px;\n}\n\n.audio-popover-backdrop.above-hero {\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\n@keyframes popoverFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.audio-popover-box {\n  width: 380px;\n  max-width: 95vw;\n  background: #18191c;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 14px;\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.65), 0 0 0 1px rgba(255, 255, 255, 0.05);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Header */\n.audio-popover-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  background: rgba(255, 255, 255, 0.03);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.audio-popover-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: 0.2px;\n}\n\n.sparkle-circle {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #a855f7, #6366f1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(168, 85, 247, 0.4);\n}\n\n.popover-close-btn {\n  background: transparent;\n  border: none;\n  color: #949ba4;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.popover-close-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n/* Live VU Meter */\n.audio-live-visualizer {\n  padding: 12px 16px;\n  background: rgba(0, 0, 0, 0.25);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.visualizer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.live-mic-label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.6px;\n  color: #b5bac1;\n}\n\n.live-engine-tag {\n  font-size: 11px;\n  font-weight: 600;\n  color: #dbdee1;\n}\n\n.vu-meter-bar {\n  width: 100%;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 999px;\n  overflow: hidden;\n  position: relative;\n}\n\n.vu-meter-fill {\n  height: 100%;\n  border-radius: 999px;\n  transition: width 0.08s ease, background-color 0.2s ease;\n  box-shadow: 0 0 10px currentColor;\n}\n\n/* Engine Choices List */\n.audio-engine-list {\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 280px;\n  overflow-y: auto;\n}\n\n.audio-engine-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.04);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.audio-engine-item:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.1);\n  transform: translateY(-1px);\n}\n\n.audio-engine-item.selected.krisp {\n  background: rgba(168, 85, 247, 0.12);\n  border-color: #a855f7;\n}\n\n.audio-engine-item.selected.krus {\n  background: rgba(16, 185, 129, 0.12);\n  border-color: #10b981;\n}\n\n.audio-engine-item.selected.rnnoise {\n  background: rgba(249, 115, 22, 0.12);\n  border-color: #f97316;\n}\n\n.audio-engine-item.selected.webrtc {\n  background: rgba(88, 101, 242, 0.12);\n  border-color: #5865F2;\n}\n\n.audio-engine-item.selected.off {\n  background: rgba(239, 68, 68, 0.12);\n  border-color: #ef4444;\n}\n\n.engine-info {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  flex: 1;\n}\n\n.engine-name-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.engine-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.engine-badge {\n  font-size: 9px;\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.engine-badge.krisp {\n  background: rgba(168, 85, 247, 0.25);\n  color: #d8b4fe;\n  border: 1px solid rgba(168, 85, 247, 0.4);\n}\n\n.engine-badge.krus {\n  background: rgba(16, 185, 129, 0.25);\n  color: #6ee7b7;\n  border: 1px solid rgba(16, 185, 129, 0.4);\n}\n\n.engine-badge.rnnoise {\n  background: rgba(249, 115, 22, 0.25);\n  color: #fdba74;\n  border: 1px solid rgba(249, 115, 22, 0.4);\n}\n\n.engine-badge.webrtc {\n  background: rgba(88, 101, 242, 0.25);\n  color: #c7d2fe;\n  border: 1px solid rgba(88, 101, 242, 0.4);\n}\n\n.engine-desc {\n  margin: 0;\n  font-size: 11px;\n  color: #949ba4;\n  line-height: 1.35;\n}\n\n.check-icon {\n  color: #5865F2;\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n\n.audio-engine-item.selected.krisp .check-icon {\n  color: #a855f7;\n}\n\n.audio-engine-item.selected.krus .check-icon {\n  color: #10b981;\n}\n\n.audio-engine-item.selected.rnnoise .check-icon {\n  color: #f97316;\n}\n\n.audio-engine-item.selected.off .check-icon {\n  color: #ef4444;\n}\n\n/* Fine-tuning Slider */\n.popover-slider-section {\n  padding: 12px 16px;\n  background: rgba(255, 255, 255, 0.02);\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.slider-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 11px;\n  font-weight: 600;\n  color: #b5bac1;\n  margin-bottom: 8px;\n}\n\n.slider-val {\n  color: #5865f2;\n  font-weight: 700;\n}\n\n.quick-popover-slider {\n  width: 100%;\n  accent-color: #5865F2;\n  height: 4px;\n  cursor: pointer;\n}\n\n/* Footer */\n.audio-popover-footer {\n  padding: 10px 16px;\n  background: rgba(0, 0, 0, 0.35);\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  display: flex;\n  justify-content: center;\n}\n\n.full-audio-settings-link {\n  background: transparent;\n  border: none;\n  color: #949ba4;\n  font-size: 11px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 6px;\n  transition: all 0.15s ease;\n}\n\n.full-audio-settings-link:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.05);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
